import { approvalFirebaseService } from "@/domain/services/approvals/approvalFirebaseService";
import type { ApprovalService } from "@/domain/services/approvals/approvalService";

export const approvalService: ApprovalService = approvalFirebaseService;
